// extracted by mini-css-extract-plugin
export default {"main":"StudentAddForm_main__-ttc7","container":"StudentAddForm_container__vrB2J","form":"StudentAddForm_form__o8Oeo"};